export default "__VITE_ASSET__D3EqxW0B__"